import { browserLocalPersistence, signInWithEmailAndPassword, User } from 'firebase/auth';
import { auth } from 'utils/firebase';

import { useAuthInfo } from 'auth';

interface PostSignInRequest {
  email: string;
  password: string;
}

/**
 * Firebase Authentication へ直接ログインする（API停止に伴いAPI経由のログインは廃止）。
 * 失敗理由（未登録・パスワード誤り・試行回数超過など）は呼び出し側で区別せず同じ文言を表示する。
 */
export const useSignIn = () => {
  const { updateCurrentUser } = useAuthInfo();

  const postSignIn = async (data: PostSignInRequest): Promise<User> => {
    await auth.setPersistence(browserLocalPersistence);
    const userCredential = await signInWithEmailAndPassword(auth, data.email, data.password);
    // onAuthStateChanged を待たずに画面遷移できるよう、コンテキストを即時更新する
    updateCurrentUser(userCredential.user);
    return userCredential.user;
  };

  return { postSignIn };
};
